import styled from 'styled-components';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  color: ${({ theme }) => theme.colors.night_blue_2};
  line-height: 1.29;
  padding-bottom: ${({ theme }) => theme.spacing(6)};
  display: flex;
  align-items: center;
`;

export default StyledLink;
